import { Box, SystemProps } from "flicket-ui";

export const MobileDivider = (props: SystemProps) => {
  return (
    <Box
      backgroundColor={"N100"}
      height="8px"
      display={{ _: "block", md: "none" }}
      mx={"-24px" as any}
      {...props}
    />
  );
};
